import { createSlice } from "@reduxjs/toolkit";
export const newFloorApplication = createSlice({
  name: "newFloorApplication",
  initialState: {
    flooringCaseFileter: {},
    flooringCaseOngoingFilters: {},
    flooringCaseRedeemedFilters: {},
    flooringCaseExpiredFilters: {},
    flooringCaseTabCount: {
      pending: 0,
      ongoing: 0,
      redeemed: 0,
      expired: 0,
    },
  },
  reducers: {
    setFloorCaseFilter: (state, action) => {
      return {
        ...state,
        flooringCaseFileter: {
          ...state.flooringCaseFileter,
          ...action.payload,
        },
      };
    },
    setFloorCaseOngoingFilter: (state, action) => {
      return {
        ...state,
        flooringCaseOngoingFilters: {
          ...state.flooringCaseOngoingFilters,
          ...action.payload,
        },
      };
    },
    setFloorCaseRedeemedFilter: (state, action) => {
      return {
        ...state,
        flooringCaseRedeemedFilters: {
          ...state.flooringCaseRedeemedFilters,
          ...action.payload,
        },
      };
    },
    setFloorCaseExpiredFilter: (state, action) => {
      return {
        ...state,
        flooringCaseExpiredFilters: {
          ...state.flooringCaseExpiredFilters,
          ...action.payload,
        },
      };
    },
    setFloorCaseTabCount: (state, action) => {
      return {
        ...state,
        flooringCaseTabCount: {
          ...state.flooringCaseTabCount,
          ...action.payload,
        },
      };
    },

    resetFloorCaseFilters: (state) => {
      return {
        flooringCaseFileter: {},
        flooringCaseOngoingFilters: {},
        flooringCaseExpiredFilters: {},
        flooringCaseRedeemedFilters: {},
        flooringCaseTabCount: {
          pending: 0,
          ongoing: 0,
          redeemed: 0,
          expired: 0,
        },
      };
    },
  },
});

export const {
  setFloorCaseFilter,
  resetFloorCaseFilters,
  setFloorCaseOngoingFilter,
  setFloorCaseRedeemedFilter,
  setFloorCaseExpiredFilter,
  setFloorCaseTabCount,
} = newFloorApplication.actions;

export default newFloorApplication.reducer;
